export class StringHelpers {
    /**
     * Capitalize string
     * Example: capitalize("foo") => Foo
     * @param s
     */
    static capitalize(s: string) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
}
